import { render, staticRenderFns } from "./CallDetails.vue?vue&type=template&id=05097cb8&"
import script from "./CallDetails.vue?vue&type=script&lang=js&"
export * from "./CallDetails.vue?vue&type=script&lang=js&"
import style0 from "./CallDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports